"use-strict";

import 'jquery';

export class Helpers {
    constructor() {
        if (!window.goTo) {
            window.goTo = id => Helpers.goTo(id)
        }
        Helpers.handleClick();
    }

    static handleClick(){
        $('.go-to').on('click', function(e){
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            Helpers.goTo($(this).attr('href'));
        });
    }

    static goTo(id) {
        $('html,body').animate({
               scrollTop: $(id).offset().top - 60
        }, 'slow');
    }

    static stripTags(string) {
        const regex = /(<([^>]+)>)/ig;
        return string.replace(regex, "");
    }
}
